import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export type AlertBannerVariant = 'error' | 'success' | 'warning' | 'info';

const VARIANT_ICONS: Record<AlertBannerVariant, string> = {
  error: 'error',
  success: 'check_circle',
  warning: 'warning',
  info: 'info',
};

@Component({
  selector: 'xemex-alert-banner',
  standalone: true,
  imports: [MatIconModule],
  styleUrl: './alert-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.alert-banner--error]': 'variant() === "error"',
    '[class.alert-banner--success]': 'variant() === "success"',
    '[class.alert-banner--warning]': 'variant() === "warning"',
    '[class.alert-banner--info]': 'variant() === "info"',
    // role=alert interrupts a screen reader; reserve it for failures and let the
    // other variants announce politely via role=status.
    '[attr.role]': 'variant() === "error" ? "alert" : "status"',
  },
  template: `
    <div class="alert-banner">
      <mat-icon class="alert-banner__icon">{{ icon() }}</mat-icon>
      <div class="alert-banner__message"><ng-content /></div>
    </div>
  `,
})
export class AlertBannerComponent {
  variant = input<AlertBannerVariant>('info');

  protected readonly icon = computed(() => VARIANT_ICONS[this.variant()]);
}
